import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { garageTypesSelect } from '@app/views/standard-plans/const/garage.constants';
import {
    getLotMigratorFormErrorMessage,
    hasLotMigratorFormError
} from '../lot-migrator-form-errors';

@Component({
    selector: 'cb-lot-migrator-rooms-parking-section',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule
    ],
    templateUrl: './lot-migrator-rooms-parking-section.component.html',
    styleUrls: ['./lot-migrator-shared-section.styles.scss']
})
export class LotMigratorRoomsParkingSectionComponent {
    @Input({ required: true }) public lotForm!: FormGroup;
    public readonly garageTypes = garageTypesSelect;

    public hasError(controlName: string): boolean {
        return hasLotMigratorFormError(this.lotForm, controlName);
    }

    public getErrorMessage(controlName: string, label: string): string {
        return getLotMigratorFormErrorMessage(this.lotForm, controlName, label);
    }
}
